import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './components/AnalyticsDashboard.css'; // shared design system (tables, cards, buttons, etc.)
import './lite.css';   // Modo rápido: switches the heavy effects off on phones
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyPerfMode } from './utils/perfMode';

// "ResizeObserver loop completed with undelivered notifications" is a harmless browser notice (charts resizing with the
// page, e.g. on a phone); the dev server would show it as a full-screen error, so it is dropped here before it gets there
window.addEventListener('error', e => {
  if (/^ResizeObserver loop/.test(e.message || '')) { e.stopImmediatePropagation(); e.preventDefault(); }
}, true);

applyPerfMode();   // before the first paint, so a phone never flashes the heavy effects

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Lets the installed app receive PDFs / images shared from the phone's Share menu (see public/sw.js).
if ('serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
